import React from 'react';
import formatCurrency from '../../func/currency_formatter';

const CardFullEach = ({ handleCardClick, data, styles, labels, displayBadges, priceLayout, showTotal, outOfStock }) => {
	let totalPrice = data.formatted_total_amount
		? data.formatted_total_amount
		: formatCurrency(Number(data.total_amount));
	let oldPrice = data?.formatted_old_price ? data?.formatted_old_price : formatCurrency(Number(data?.old_price));
	let price = data?.formatted_price ? data?.formatted_price : formatCurrency(Number(data?.price));

	if (outOfStock) {
		totalPrice = window.formattedString
			? window.formattedString.replace(/0.00|0,00/g, Number(1 * data?.amount).toString())
			: formatCurrency(Number(1.0 * data.amount));
		oldPrice = window.formattedString
			? window.formattedString.replace(/0.00|0,00/g, '1.00')
			: formatCurrency(Number(1));
		price = window.formattedString ? window.formattedString.replace(/0.00|0,00/g, '1.00') : formatCurrency(Number(1));
	}

	return (
		<div
			className={`productsRows__item`}
			onClick={() => {
				handleCardClick();
			}}
			style={styles?.card}
		>
			<div style={styles?.heading} className={`productsRows__itemHeading`}>
				{outOfStock ? 'Out Of Stock' : data.status}
			</div>
			<div className="productsRows__itemContentWrap">
				<div className="image__wrapper" style={{ marginLeft: '14px' }}>
					<img
						className="productsRows__itemImage mon-img-176-h"
						src={data.image.url}
						alt="product x4"
						style={{ height: '100%', width: 'auto' }}
					/>
				</div>
				{displayBadges && !outOfStock && (
					<div className="productsRows__itemPerks productsRows__itemPerks--active">
						<div style={styles?.shippingBadge}>{labels?.shipping}</div>
						<div style={styles?.savingsBadge}>
							{labels?.saveLabel} -{data.you_save_percentage}%
						</div>
					</div>
				)}
				<div className="itemEachContent">
					<div className="itemEachContent__itemNumber" style={styles?.primaryColor}>
						{data.amount}x
					</div>
					<div className="itemEachContent__itemName" style={styles?.primaryColor}>
						{data.display_name}
					</div>
					<div className="itemEachContent__itemEach">
						<div style={styles?.priceColor}>{price}</div>
						<div>{labels?.eachLabel}</div>
					</div>
					{showTotal && (
						<div className="itemEachContent__itemTotal" style={priceLayout?.oldPricePosition}>
							<div style={styles?.totalColor}>
								{labels.totalLabel}: {totalPrice}
							</div>
							<s style={{ ...styles?.secondaryColor, ...priceLayout?.totalPosition }}>{oldPrice}</s>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default CardFullEach;
